const COLORS = {
  background: "#F7F2EF",
  title: "#3B625F",
  text: "#666666",
  button: "#FD7C7B",
  nav: "#FAF9F7",
};

export default COLORS;
